import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { useGetTheme } from '../../../../../hooks/use-get-theme';

const useHomepageModuleWrapper = () => {
  const theme = useGetTheme();
  const muiTheme = useTheme();

  return useMemo(
    () => ({
      theme,
      muiTheme,
    }),
    [theme, muiTheme],
  );
};

export default useHomepageModuleWrapper;
